/*jslint node: true, browser: true*/

"use strict";

var ko = require("pli/knockout");
var pli = require("pli/forms");
var pliObservable = require("pli/forms-knockoutcontrols");

var createCommentsFactory = require("../document/commentViewModel");
var createDoisFactory = require("../document-doi");
var createObligationsFactory = require("../document-obligation");
var createRelatedDocsFactory = require("../document-relateddoc");
var createRelatedWellsFactory = require("../document-relatedwell");
var entityRegistry = require("../entity-registry");
var selectionForm = require("../common-selectionform");
var viewModelInit = require("../document/viewModelInitExtensions");
var LandsRightsEditGridViewModel = require("../document-landright-ts/landsRightsEditGridViewModel");

require("pli/ko-editgrid").registerEditGridBinding();
require("../document/commentDeleteForm");
require("../picklist-contact");

//-------------------------------------------
function findMaxSplitNumber(splits) {
    var l, i, n, max = 0;
    if (splits) {
        for (i = 0, l = splits.length; i < l; i += 1) {
            n = splits[i].number();
            if (n > max) { max = n; }
        }
    }
    return max;
}


//-------------------------------------------
function renumberSplits(splits, start) {
    var l, i;
    if (splits) {
        for (i = 0, l = splits.length; i < l; i += 1) {
            splits[i].number = start + i + 1;
        }
    }
    return splits;
}


//-------------------------------------------
function getRelatedDocumentId(relatedDoc) {
    return relatedDoc.id();
}


//-------------------------------------------
function checkCanDeleteSplit() {
    /// <summary>
    /// Check if split isn't last, don't use in sibling splits
    /// and doesn't have dependencies
    /// </summary>
    /*jshint validthis: true */
    var i, l, splitName, splits, relDocs;
    if (this().length === 1) {
        pli.viewModel.extras.notificationMessage.show({
            title: "Cannot delete split",
            message: "The document must contain at least one split"
        });
        return true;
    }
    splits = this();
    splitName = pli.viewModel.id.peek() + " - " + this.current().id.peek();
    for (i = 0, l = splits.length; i < l; i += 1) {
        relDocs = ko.utils.arrayMap(splits[i].relatedDocs(), getRelatedDocumentId);
        if (ko.utils.arrayIndexOf(relDocs, splitName) >= 0) {
            pli.viewModel.extras.notificationMessage.show({
                title: "Cannot delete split",
                message: "This split has a relationship with split " + splits[i].id.peek() + " on this document."
            });
            return true;
        }
    }

    return this.factory.factories.checkForDependencies.bind(this)();
}


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// SplitViewModelExtensions static class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//---------------------------------------
function SplitViewModelExtensions(factories) {
    this.guid = ko.observable(null);
    this.number = pliObservable(null, "N0", "required", "numeric");
    this.number.dispose = SplitViewModelExtensions.prototype._disposeNumber;
    this.id = ko.computed(SplitViewModelExtensions.prototype._computeId, this);
    this.status = pliObservable(null, entityRegistry.splitStatus.getPicklistBehaviourData(), "picklist");
    this.status.updateDate = pliObservable(null, null, "date");
    this.status.isActive = ko.computed(SplitViewModelExtensions.prototype._computeIsStatusActive, this.status);
    this.operator = pliObservable(null, entityRegistry.contact.getPicklistBehaviourData(), "picklist");
    this.description = pliObservable();

    this.dois = factories.dois.createObservableArray();
    this.obligations = factories.obligations.createObservableArray();
    this.relatedDocs = factories.relatedDocs.createObservableArray();
    this.relatedDocs.owner = this; // store link to the current split
    this.relatedWells = factories.relatedWells.createObservableArray();
    this.remarks = factories.comments.createObservableArray();
    this.tracts = ko.observableArray();

    this.addComment = SplitViewModelExtensions.prototype.addComment.bind(this);
    this.editComment = SplitViewModelExtensions.prototype.editComment.bind(this);
    this.deleteComment = SplitViewModelExtensions.prototype.deleteComment.bind(this);

    if (!this.extras) {
        this.extras = function SplitViewExtensionsExtras() { return; };
    }

    this.extras.newRemark = ko.observable();
    this.extras.newRemark.expanded = ko.observable();
    this.extras.dependencies = ko.observableArray();
    this.extras.dependencyHint = "  You may set the status of this split to 'Inactive'. All Related Document entries and links (DOI & Royalty) must be removed, and any changes must be saved, before this Split may be deleted.";
    this.extras.statusDescription = ko.computed(SplitViewModelExtensions.prototype._computeStatusDescription, this);
    this.extras.remarksLink = ko.computed(SplitViewModelExtensions.prototype._computeRemarksLink, this);
    this.extras.commentTitle = ko.computed(SplitViewModelExtensions.prototype._commentTitleComputed, this);
    this.extras.commentButtonEnabled = ko.computed(SplitViewModelExtensions.prototype._commentButtonEnabledComputed, this);

    this.extras.landsRightsEditGrid = new LandsRightsEditGridViewModel(this.tracts);

    // this is needed so that if there are server side errors, they are remembered when the user switches items.
    this.extras.landsRightsEditGrid.editGrid.focusedItem.subscribe(function (item) {
        if (item && item._errors) {
            if (item._errors.location) {
                this.extras.landsRightsEditGrid.editGrid.viewItem().location.setErrorMessage(item._errors.location);
            }
            if (item._errors.sections) {
                this.extras.landsRightsEditGrid.editGrid.viewItem().sections.setErrorMessage(item._errors.sections);
            }
        }
    }, this);
}

//---------------------------------------
SplitViewModelExtensions.prototype.completeViewModel = function completeSplit() {
    if (this.number() === null) {
        this.number(findMaxSplitNumber(this.extras.owner()) + 1);
    }
};


//---------------------------------------
SplitViewModelExtensions.prototype.initGridArray = function initSplitGridArray(gridArray) {
    gridArray.copyItems = gridArray.factory.factories.secureAction(SplitViewModelExtensions.prototype._copyItems, gridArray);
    gridArray.deleteAndCloseCurrent = gridArray.factory.factories.secureAction(gridArray.deleteAndCloseCurrent, gridArray, checkCanDeleteSplit.bind(gridArray));
    gridArray.openNew = gridArray.factory.factories.secureAction(gridArray.openNew, gridArray);
};


//---------------------------------------
SplitViewModelExtensions.prototype.loadViewModel = function loadSplit(record) {
    this.guid(record.guid || null);
    this.number.load(record.number);
    this.status.load(record.status);
    this.status.updateDate.load(record.statusUpdateDate);
    this.operator.load(record.operator);
    this.description.load(record.description);

    this.dois.loadViewModel(record.dois || []);
    this.obligations.loadViewModel(record.obligations);
    this.relatedDocs.loadViewModel(record.relatedDocs);
    this.relatedWells.loadViewModel(record.relatedWells);
    this.remarks.loadViewModel(record.remarks);

    this.tracts(record.tracts);

    this.extras.dependencies(record.dependencies || []);
    this.extras.landsRightsEditGrid.loadViewModel(record.tracts || []);
};


//---------------------------------------
SplitViewModelExtensions.prototype.addComment = function addComment() {
    var value = this.extras.newRemark.peek();
    if (value) {
        var newRemark = this.remarks.createItem();

        newRemark.message(value);
        newRemark.extras.createdByName(pli.viewModel.extras.userName());
        newRemark.extras.editMessage(value);
        newRemark.extras.editMode(false);

        // Insert remark at the front of the collection
        this.remarks.unshift(newRemark);

        //clear the textarea, and refocus it
        this.extras.newRemark("");
        this.extras.newRemark.expanded(true);
    }
};


//---------------------------------------
SplitViewModelExtensions.prototype.editComment = function editComment(comment) {
    // Enforces editability of only one comment at a time
    if (this.remarks) {
        ko.utils.arrayForEach(this.remarks(), function (remark) {
            if (remark.extras) {
                remark.extras.editMode(false);
            }
        });
    }

    // Enable edit mode for the target comment
    if (comment && comment.extras) {
        comment.extras.editMode(true);
    }
};


//---------------------------------------
SplitViewModelExtensions.prototype.deleteComment = function deleteComment(comment) {
    var self = this;

    // Open comment delete confirmation dialog
    pli.forms.registry.deleteCommentForm.open(function () {
        if (comment) {
            self.remarks.remove(comment);
        }
    });
};

//---------------------------------------
SplitViewModelExtensions.prototype._computeId = function computeSplitId() {
    /// <summary>
    /// Convert split id (numeric) to string value when
    /// `number` is updated.
    /// </summary>
    var value = this.number();
    return (typeof value === "number" ? value.toString() : null);
};


//-------------------------------------------
SplitViewModelExtensions.prototype._computeIsStatusActive = function computeIsStatusActive() {
    /// <summary>
    /// Compute whether "this" split status
    /// is active or not (boolean flag).
    /// </summary>
    var statusDescriptorArray = (this.item && this.item());
    return (statusDescriptorArray && statusDescriptorArray.length > 2 && statusDescriptorArray[2].toUpperCase() === "ACTIVE");
};


//-------------------------------------------
SplitViewModelExtensions.prototype._computeStatusDescription = function computeStatusDescription() {
    /// <summary>
    /// Compute the description text under the status.
    /// This holds the last updated date for the status.
    /// </summary>
    var date = this.status.updateDate;

    return date && date.raw ? "Updated on " + date.raw() : null;
};


//-------------------------------------------
SplitViewModelExtensions.prototype._copyItems = function copyContractSplits() {
    /// <summary>
    /// Show selection form that allows users
    /// to find and copy splits to this array.
    /// </summary>
    /// <remarks>
    /// Expects "this" to be a grid observable
    /// array that creates and stores contract splits.
    /// </remarks>
    var entity = entityRegistry[pli.forms.root.id],
        getDetailsApi = "Geo-".concat(pli.forms.root.pascalCaseId).concat("-GetSplitDetails"),
        searchApi = "Geo-".concat(pli.forms.root.pascalCaseId).concat("-SearchSplits"),
        selectionTitle = "Copy ".concat((entity && entity.type) || pli.forms.root.pascalCaseId).concat(" Splits");

    selectionForm.open({
        getDetailsApi: getDetailsApi,
        getDetailsDataBuilder: function (items) { // send only the guids
            var guidIndex = items[0].length - 1;
            return ko.utils.arrayMap(items, function (item) { return item[guidIndex]; });
        },
        searchApi: searchApi,
        multiSelect: true,
        text: {
            acceptButton: "Copy",
            iconClass: "sprite-copy-16",
            examples: [
                "<strong>File Numbers</strong>:<br>C-12 will find C-123, C-1234, etc.<br>M001 will find M001, M0019, etc.",
                "<strong>Areas</strong>:<br>river will find GHOST RIVER, TWO RIVERS, etc.",
                "<strong>Lands</strong>:<br>68 17 4 will find Twp 68-Rge 17-W4M<br>94 h 13 c will find 94-H-11-C<br>Note: Sections are not searched",
                "<strong>Combinations</strong>:<br>C, lloyd will find contracts (starting with C) in the Lloydminster area"
            ],
            title: selectionTitle
        },
        onAcceptedContext: this,
        onAccepted: function (newSplits) {
            newSplits = selectionForm.utils.resetGuids(newSplits);
            selectionForm.utils.pushObjectItems({
                targetArray: this,
                records: renumberSplits(newSplits, findMaxSplitNumber(this()))
            });
        }
    });
};


//---------------------------------------
SplitViewModelExtensions.prototype._computeRemarksLink = function computeRemarksLink() {
    var h = pli.forms.crumbs().end;
    if (h && h.previous) {
        return h.previous.hash.concat("/remarks");
    }
    return null;
};


//-------------------------------------------
SplitViewModelExtensions.prototype._commentTitleComputed = function commentTitleComputed() {
    /// <summary>
    /// Computes a string indicating how many comments are in the list
    /// </summary>
    /// <returns type="string">Returns a string, ex: '10 Comments'</returns>

    var count = this.remarks().length;
    return count + " Comment" + ((count === 1) ? "" : "s");
};


//-------------------------------------------
SplitViewModelExtensions.prototype._commentButtonEnabledComputed = function commentButtonEnabledComputed() {
    /// <summary>
    /// Computes if to activate the button or not, depending on if there are any text entered
    /// </summary>

    var v = this.extras.newRemark();
    return (v && ko.utils.stringTrim(v) !== "");
};


//---------------------------------------
SplitViewModelExtensions.prototype._disposeNumber = function disposeSplitNumber() {
    this.load(null);
};


viewModelInit.onBindingsApplied(function startSearchBindingsApplied(viewModel) {
    // setup menu for lands rights new button
    var menuItems = [
        { title: "Land", sprite: "sprite-land-16", name: "land" },
        { title: "Comment", sprite: "sprite-comment-16", name: "comment" },
        { type: "Separator" },
        { title: "Copy From...", sprite: "sprite-copy-16", name: "copy" }
    ];

    if (!pli.forms.navigationPages.surfaceLease_splits_form_landsRights) {
        menuItems.splice(1, 0, { title: "Right", sprite: "sprite-right-16", name: "right" });
    }

    var menuHash = "#anonymous_new";

    if (pli.forms.navigationPages.mineralLease_splits_form_landsRights) {
        menuHash = "#mineralLease_splits_form_landsRights_new";
    } else if (pli.forms.navigationPages.surfaceLease_splits_form_landsRights) {
        menuHash = "#surfaceLease_splits_form_landsRights_new";
    } else if (pli.forms.navigationPages.contract_splits_form_landsRights) {
        menuHash = "#contract_splits_form_landsRights_new";
    }

    pli.menu.setup({
        clickSelector: menuHash,
        items: menuItems,
        click: function (menuItem) {
            if (menuItem.name() === "copy") {
                viewModel.splits.current().extras.landsRightsEditGrid.copyItems();
            } else {
                viewModel.splits.current().extras.landsRightsEditGrid.addItem(menuItem.name());
            }
        }
    });
});


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Export
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

module.exports = {
    createFactories: function createExtraSplitFactories(rootId, calculateTotalDoiPercentageOnClient) {
        return {
            dois: createDoisFactory(rootId, calculateTotalDoiPercentageOnClient),
            obligations: createObligationsFactory(rootId),
            relatedDocs: createRelatedDocsFactory(rootId),
            relatedWells: createRelatedWellsFactory(rootId),
            comments: createCommentsFactory(rootId)
        };
    },
    mixins: {
        completeSplit: SplitViewModelExtensions.prototype.completeViewModel,
        initSplit: SplitViewModelExtensions,
        initSplitGridArray: SplitViewModelExtensions.prototype.initGridArray,
        loadSplit: SplitViewModelExtensions.prototype.loadViewModel
    }
};



//////////////////
// WEBPACK FOOTER
// ./app/document-split/SplitViewModelExtensions.js
// module id = 545
// module chunks = 49